import React, { useCallback, useMemo, useState } from "react";
import { useCartContext } from "../../cart";
import { DealType } from "../domain/DealSelection.model";
import SyncAltTwoToneIcon from "@mui/icons-material/SyncAltTwoTone";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { GtmService } from "../../infrastructure/analytics/GtmService";

const isSelectionInvalid = (productSelection) => {
    const { price, quantity, availability, dealType } = productSelection;
    return (
        price?.sellingPrice <= 0 ||
        quantity <= 0 ||
        (dealType === DealType.LOT && availability.isAvailable === false)
    );
};


const handleAddToCart = async ({ setLoading, addProduct, afterAddToCart, productSelection, product }) => {
    try {
        setLoading(true);
        await addProduct(productSelection);
        GtmService.logAddToCart(product, productSelection.quantity, productSelection.price);
        toast.success(`Producto agregado al carrito exitosamente.`)
    } catch (error) {
        toast.error(`No pudo agregarse el producto al carrito. Por favor, reintente más tarde o contacte con nosotros.`)
    } finally {
        afterAddToCart();
        setLoading(false);
    }
};

/**
 * @param productSelection
 * @returns {Element}
 * @constructor
 */
export const AddToCartButton = ({ productSelection, hasStock, afterAddToCart = () => null, product }) => {
    const { isOnCart, addProduct } = useCartContext();
    const [loading, setLoading] = useState(false);

    const invalidSelection = useMemo(() => isSelectionInvalid(productSelection), [productSelection]);
    const shouldAdd = useMemo(() => isOnCart(productSelection?.id), [isOnCart, productSelection?.id]);

    const disabled = useMemo(() => invalidSelection || !hasStock, [invalidSelection, hasStock]);

    const addToCart = useCallback(async () => {
        await handleAddToCart({ setLoading, addProduct, afterAddToCart, productSelection, product });
    }, [setLoading, addProduct, afterAddToCart, productSelection, product]);

    return (
        <button type="button" className="btn btn-primary" disabled={disabled} onClick={addToCart}>
            <div className="d-flex gap-1 align-items-center">
                {
                    shouldAdd === true ? (
                        <>
                            <SyncAltTwoToneIcon />&nbsp;<span>Actualizar</span>
                        </>
                    ) : (
                        <>
                            <ShoppingCartCheckoutIcon />&nbsp;<span>Agregar</span>
                        </>
                    )
                }
                {loading && <Spinner size="sm" />}
            </div>
        </button>
    )
}
